(function () {
  const Core = window.RB.Core;
  const Flow = window.RB.Flow;

  const ZONE_LISTS = { trash: "trash", banish: "banish", hand: "hand", runeDeck: "runeDeck" };

  Object.assign(Flow, {
    channel(state, p, n, opts) {
      opts = opts || {};
      const player = state.players[p];
      let done = 0;
      for (let i = 0; i < n && player.runeDeck.length; i++) {
        const iid = player.runeDeck.shift();
        const o = state.objs[iid];
        o.zone = "board";
        o.loc = { t: "base", p: p };
        o.ready = !opts.exhausted;
        done++;
      }
      if (done) {
        Core.log(state, player.name + " channels " + done + " rune" + (done > 1 ? "s" : "") + ".", { k: "resource", p: p });
        RB.FX.emit(state, { type: "channel", player: p, n: done });
      }
      state.needCleanup = true;
    },

    draw(state, p, n) {
      const player = state.players[p];
      for (let i = 0; i < n; i++) {
        if (!Flow.refillDeck(state, p)) {
          if (state.over) return;
          continue;
        }
        RB.Setup.drawRaw(state, p);
      }
      state.turnFacts.players[p].drawn += n;
      Core.log(state, player.name + " draws " + n + " (hand " + player.hand.length + ").", { k: "draw", p: p });
      RB.FX.emit(state, { type: "draw", player: p, n: n });
    },

    burnOut(state, p) {
      const player = state.players[p];
      const opp = state.players[Core.otherPlayer(p)];
      Core.log(state, player.name + " burns out!", { k: "game", p: p });
      const trashCards = player.trash.filter(function (iid) {
        return !state.objs[iid].token;
      });
      player.trash = player.trash.filter(function (iid) {
        return trashCards.indexOf(iid) < 0;
      });
      for (const iid of trashCards) {
        const n = Core.rebirth(state, iid);
        n.zone = "deck";
        player.mainDeck.push(n.iid);
      }
      Kernel.shuffle(state, player.mainDeck);
      opp.points += 1;
      RB.FX.emit(state, { type: "scored", player: opp.idx, n: 1, source: null, reason: "burnout" });
      Core.log(state, opp.name + " gains 1 point from burn out (" + opp.points + ").", { k: "score", p: opp.idx });
      if (opp.points >= Core.victoryScore(state) && opp.points > player.points) Flow.declareWinner(state, opp.idx);
    },

    addBattlefield(state, cardRef, owner) {
      const c = RB.Setup.findCard(cardRef);
      if (!c) throw new Error("unknown battlefield " + cardRef);
      const bf = Core.makeBattlefield(state, c.id, owner);
      state.battlefields.push(bf.iid);
      Core.log(state, c.name + " is added to the board.", { k: "zone", p: owner, iids: [bf.iid] });
      state.needCleanup = true;
      return bf.iid;
    },

    swapBattlefieldObject(state, oldIid, newIid) {
      const idx = state.battlefields.indexOf(oldIid);
      if (idx < 0) return;
      state.battlefields[idx] = newIid;
      for (const iid in state.objs) {
        const o = state.objs[iid];
        if (o.loc && o.loc.t === "bf" && o.loc.iid === oldIid) o.loc = { t: "bf", iid: newIid };
      }
      if (state.showdown && state.showdown.bf === oldIid) state.showdown.bf = newIid;
      for (const key of ["conqueredBfs", "heldBfs", "damaged"]) {
        const map = state.turn[key];
        if (map && map[oldIid] !== undefined) { map[newIid] = map[oldIid]; delete map[oldIid]; }
      }
      for (const f of state.fx || []) if (f.bf === oldIid) f.bf = newIid;
      const old = state.objs[oldIid];
      old.zone = "aside";
      old.loc = null;
      old.facedownIid = null;
      if (old.facedownIid2) old.facedownIid2 = null;
      state.needCleanup = true;
    },

    replaceBattlefield(state, oldIid, cardRef) {
      const c = RB.Setup.findCard(cardRef);
      if (!c) throw new Error("unknown battlefield " + cardRef);
      const old = state.objs[oldIid];
      if (!old) return null;
      const nb = Core.makeBattlefield(state, c.id, old.owner, old.controller);
      Flow.copyBfState(old, nb);
      nb.replacedBf = oldIid;
      Core.log(state, Core.name(state, oldIid) + " is replaced by " + c.name + ".",
        { k: "zone", iids: [oldIid, nb.iid] });
      Flow.swapBattlefieldObject(state, oldIid, nb.iid);
      return nb.iid;
    },

    restoreBattlefield(state, tokenIid) {
      const tok = state.objs[tokenIid];
      if (!tok || !tok.replacedBf) return null;
      const back = state.objs[tok.replacedBf];
      if (!back) return null;
      back.zone = "board";
      back.loc = null;
      back.controller = tok.controller;
      Flow.copyBfState(tok, back);
      Core.log(state, Core.name(state, tokenIid) + " is replaced by " + Core.name(state, back.iid) + " again.",
        { k: "zone", iids: [tokenIid, back.iid] });
      delete tok.replacedBf;
      Flow.swapBattlefieldObject(state, tokenIid, back.iid);
      return back.iid;
    },

    hideCapacity(state, bfIid) {
      const sc = RB.Scripts.forCard(state, bfIid);
      return sc && sc.extraHideSlot ? 2 : 1;
    },

    hiddenAt(state, bfIid) {
      const bf = state.objs[bfIid];
      const out = [];
      if (!bf) return out;
      if (bf.facedownIid) out.push(bf.facedownIid);
      if (bf.facedownIid2) out.push(bf.facedownIid2);
      return out;
    },

    hideSlotFree(state, bfIid) {
      const bf = state.objs[bfIid];
      if (!bf) return false;
      if (!bf.facedownIid) return true;
      return Flow.hideCapacity(state, bfIid) > 1 && !bf.facedownIid2;
    },

    setHidden(state, bfIid, iid) {
      const bf = state.objs[bfIid];
      if (!bf.facedownIid) { bf.facedownIid = iid; return true; }
      if (Flow.hideCapacity(state, bfIid) > 1 && !bf.facedownIid2) { bf.facedownIid2 = iid; return true; }
      return false;
    },

    clearHidden(state, bfIid, iid) {
      const bf = state.objs[bfIid];
      if (!bf) return;
      if (bf.facedownIid === iid) {
        bf.facedownIid = bf.facedownIid2 || null;
        if (bf.facedownIid2) bf.facedownIid2 = null;
        return;
      }
      if (bf.facedownIid2 === iid) bf.facedownIid2 = null;
    },

    hiddenBfOf(state, iid) {
      for (const bfIid of state.battlefields) {
        if (Flow.hiddenAt(state, bfIid).indexOf(iid) >= 0) return bfIid;
      }
      return null;
    },

    spendBuff(state, iid, p) {
      const o = state.objs[iid];
      if (!o || !(o.buffs > 0)) return 0;
      const n = o.buffs;
      o.buffs = 0;
      RB.FX.emitHeard(state, { type: "buffSpent", iid: iid, player: p === undefined ? o.controller : p, n: n });
      return n;
    },

    recall(state, iid) {
      const o = state.objs[iid];
      if (o.zone !== "board") return;
      o.loc = { t: "base", p: o.controller };
    },

    moveImmune(state, iid, by) {
      const o = state.objs[iid];
      if (!o || by === undefined || by === null || by === o.controller) return false;
      return (o.attachments || []).some(function (a) {
        const sc = RB.Scripts.forCard(state, a);
        return !!(sc && sc.hostNoEnemyMove);
      });
    },

    moveUnits(state, iids, dest, opts) {
      opts = opts || {};
      const moved = [];
      for (const iid of iids) {
        const o = state.objs[iid];
        if (!o || o.zone !== "board") continue;
        if (Flow.moveImmune(state, iid, opts.by)) {
          Core.log(state, Core.name(state, iid) + " can't be moved by enemy spells and abilities.",
            { k: "move", p: o.controller, iids: [iid] });
          continue;
        }
        const from = o.loc;
        o.loc = dest;
        o.flags.movedThisTurn = (o.flags.movedThisTurn || 0) + 1;
        moved.push(iid);
        if (dest.t === "bf") Flow.markContested(state, dest.iid, o.controller);
        RB.FX.emit(state, { type: "move", iid: iid, from: from, to: dest, by: opts.by, player: opts.by });
      }
      state.needCleanup = true;
      return moved;
    },

    dealDamage(state, deals) {
      for (const d of deals) {
        const o = state.objs[d.iid];
        if (!o || o.zone !== "board") continue;
        let amt = d.amt;

        const dsc = RB.Scripts.forCard(state, d.iid);
        if (dsc && dsc.damageImmuneCond &&
          !(dsc.damageImmuneNonCombat && !d.src) &&
          !(dsc.damageImmuneFromEnemy && d.by === o.controller) &&
          RB.Scripts.staticCond(state, d.iid, o.controller, dsc.damageImmuneCond)) {
          Core.log(state, Core.name(state, d.iid) + " takes no damage.", { k: "damage", p: d.by, iids: [d.iid] });
          continue;
        }

        for (const f of state.fx) {
          if (f.k !== "amplifyDamage" || f.iid !== d.iid || amt <= 0) continue;
          amt = amt * (f.times === undefined ? 2 : f.times);
        }
        for (const f of state.fx) {
          if (f.k !== "preventAll" || amt <= 0) continue;
          if (f.nonCombatOnly && !d.src) continue;
          if (f.iid && f.iid !== d.iid) continue;
          if (f.byEnemyOf !== undefined && d.by === f.byEnemyOf) continue;
          amt = 0;
        }
        if (amt <= 0) continue;
        for (const f of state.fx) {
          if (f.k === "prevent" && f.iid === d.iid && amt > 0) {
            const use = f.amount === "all" ? amt : Math.min(f.amount, amt);
            amt -= use;
            if (f.amount === "all") {
              f.done = true;
            } else {
              f.amount -= use;
              if (f.amount <= 0) f.done = true;
            }
          }
        }
        state.fx = state.fx.filter(function (f) { return !f.done; });
        if (amt <= 0) continue;
        o.damage.push({ amt: amt, by: d.by, src: d.src, bySpell: !!d.bySpell });
        if (state.turn.damaged) state.turn.damaged[d.iid] = true;
        if (d.bonus) {
          Core.log(state, Core.name(state, d.iid) + " takes " + amt + " (" + (d.base || 0) +
            (d.bonusFrom || []).map(function (b) { return " +" + b.n + " " + b.name; }).join("") + ").",
            { k: "damage", p: d.by, iids: [d.iid] });
        }
        RB.FX.emit(state, {
          type: "takeDamage", iid: d.iid, amt: amt, by: d.by, src: d.src, bf: d.bf || null,
          base: d.base, bonus: d.bonus || 0, bonusFrom: d.bonusFrom || [],
        });
      }
      state.needCleanup = true;
    },

    staticDeathReplace(state, iid) {
      const o = state.objs[iid];
      if (!o) return null;
      for (const s of Core.ruleSources(state, "staticDeathReplace")) {
        const src = s.iid, so = s.obj, r = s.rule;
        if (src === iid && r.excludeSelf !== false) continue;
        if (r.unitsOnly !== false && !Core.isType(state, iid, "unit")) continue;
        if (!RB.Scripts.auraMatch(state, r, src, so, iid, o)) continue;
        if (r.lessMightThanSource &&
          !((Core.effMight(state, iid) || 0) < (Core.effMight(state, src) || 0))) continue;
        if (r.inCombat && !(state.showdown && state.showdown.combat &&
          o.loc && o.loc.t === "bf" && o.loc.iid === state.showdown.bf)) continue;
        return { rule: r, source: src };
      }
      return null;
    },

    pendingDeathReplace(state, iid) {
      const o = state.objs[iid];
      if (!o) return null;
      return state.fx.find(function (f) {
        if (f.k !== "optReplaceDeath") return null;
        if ((f.declined || []).indexOf(iid) >= 0) return false;
        if (f.iid && f.iid !== iid) return false;
        if (f.controller !== undefined && o.controller !== f.controller) return false;
        if (f.requiresBuff && !(o.buffs > 0)) return false;
        if (f.unitsOnly && !Core.isType(state, iid, "unit")) return false;
        const src = f.source && state.objs[f.source];
        if (f.exhaustsSource && (!src || src.zone === "trash" || !src.ready)) return false;
        if (f.killsSource && (!src || (src.zone !== "board" && src.zone !== "legendZone"))) return false;
        return true;
      }) || null;
    },

    killObjs(state, iids, attribution) {
      for (const iid of iids) {
        const o = state.objs[iid];
        if (!o || o.zone !== "board") continue;
        if (!(attribution && attribution.skipReplace)) {
          const optRep = Flow.pendingDeathReplace(state, iid);
          if (optRep) {
            state.tasks.push({ k: "deathChoice", iid: iid, fxId: optRep.id, attribution: attribution || null, answers: {} });
            continue;
          }
          const statRep = Flow.staticDeathReplace(state, iid);
          if (statRep) {
            state.tasks.push({
              k: "deathChoice", iid: iid, fxId: null, rule: statRep.rule, ruleSrc: statRep.source,
              attribution: attribution || null, answers: {},
            });
            continue;
          }
        }
        const banishIdx = state.fx.findIndex(function (f) {
          return f.k === "banishInsteadOfDie" && f.iid === iid;
        });
        if (banishIdx >= 0) {
          state.fx.splice(banishIdx, 1);
          Core.log(state, Core.name(state, iid) + " is banished instead of dying.",
            { k: "death", p: o.controller, iids: [iid] });
          Flow.toBanish(state, iid);
          continue;
        }
        const replaceIdx = state.fx.findIndex(function (f) {
          return f.k === "recallInsteadOfDie" && f.iid === iid;
        });
        if (replaceIdx >= 0) {
          state.fx.splice(replaceIdx, 1);
          Flow.recallExhausted(state, iid, { log: Core.name(state, iid) + " is recalled exhausted instead of dying." });
          continue;
        }
        const guardian = (o.attachments || []).find(function (aIid) {
          const asc = RB.Scripts.forCard(state, aIid);
          return !!(asc && asc.attachedDeathReplace);
        });
        if (guardian) {
          const rule = RB.Scripts.forCard(state, guardian).attachedDeathReplace;
          Core.log(state, Core.name(state, guardian) + " is killed instead of " + Core.name(state, iid) + ".",
            { k: "death", p: o.controller, iids: [guardian, iid] });
          if (rule.killGear) Flow.killObjs(state, [guardian], { via: "deathReplace" });
          else Flow.detach(state, guardian);
          if (rule.recall) {
            Flow.recallExhausted(state, iid, { heal: !!rule.heal, exhaust: !!rule.exhaust });
          } else {
            if (rule.heal) o.damage = [];
            if (rule.exhaust) o.ready = false;
          }
          state.needCleanup = true;
          continue;
        }
        const snapshot = {
          iid: iid, name: Core.name(state, iid), loc: o.loc,
          controller: o.controller, owner: o.owner,
          might: Core.might(state, iid),
          buffs: o.buffs, stunned: o.stunned,
          isUnit: Core.isType(state, iid, "unit"),
          tags: Core.tags(state, iid),
        };
        state.turnFacts.players[o.controller].enemyDied = true;
        if (snapshot.isUnit) {
          state.turnFacts.players[o.controller].unitDied = true;
          if (state.turn.phase === "beginning") state.turnFacts.players[o.controller].unitDiedBeginning = true;
        }
        RB.FX.collectDeathTriggers(state, iid, snapshot);
        const dkDouble = RB.Scripts.anySource(state, "deathknellDouble", { controller: o.controller });
        if (dkDouble && (RB.Scripts.forCard(state, iid) || {}).deathknell) {
          RB.FX.collectDeathTriggers(state, iid, snapshot);
        }
        for (const aIid of o.attachments.slice()) Flow.detach(state, aIid);
        const dyingScript = RB.Scripts.forCard(state, iid);
        snapshot.trashIid = Flow.toTrash(state, iid);
        Core.log(state, snapshot.name + " dies.", { k: "death", p: snapshot.controller, iids: [snapshot.trashIid || iid] });
        RB.FX.emit(state, { type: "dies", snapshot: snapshot, attribution: attribution });
        if (dyingScript && dyingScript.deathRecycle && snapshot.trashIid) {
          Flow.recycleCards(state, [snapshot.trashIid]);
        }
      }
      state.needCleanup = true;
    },

    leaveToZone(state, iid, zone) {
      const o = state.objs[iid];
      RB.FX.collectLeaveTriggers(state, iid);
      if (o.attachedTo) Flow.detach(state, iid);
      if ((o.attachments || []).length) {
        for (const aIid of o.attachments.slice()) Flow.detach(state, aIid);
        state.needCleanup = true;
      }
      Flow.removeFromZoneLists(state, iid);
      if (o.token) {
        delete state.objs[iid];
        return null;
      }
      const n = Core.rebirth(state, iid);
      n.zone = zone;
      const list = ZONE_LISTS[zone];
      if (list) state.players[n.owner][list].push(n.iid);
      return n.iid;
    },

    refillDeck(state, p) {
      const player = state.players[p];
      if (player.mainDeck.length) return true;
      Flow.burnOut(state, p);
      return !state.over && player.mainDeck.length > 0;
    },

    markContested(state, bfIid, p) {
      const bf = state.objs[bfIid];
      if (bf.controller !== p && bf.contestedBy === null) bf.contestedBy = p;
    },

    contestByIntruder(state, bfIid) {
      const bf = state.objs[bfIid];
      for (const iid of Core.unitsAt(state, { t: "bf", iid: bfIid })) {
        const o = state.objs[iid];
        if (bf.controller !== o.controller) {
          bf.contestedBy = o.controller;
          state.needCleanup = true;
          return;
        }
      }
    },

    copyBfState(from, to) {
      to.contestedBy = from.contestedBy;
      to.scoredBy = (from.scoredBy || []).slice();
      to.facedownIid = from.facedownIid || null;
      if (from.facedownIid2) to.facedownIid2 = from.facedownIid2;
      to.stagedShowdown = from.stagedShowdown;
      to.stagedCombat = from.stagedCombat;
    },

    leaveOrigin(state, iid) {
      const o = state.objs[iid];
      return { loc: o.zone === "board" ? o.loc : null, zone: o.zone, controller: o.controller };
    },

    trashRedirectedToBanish(state, owner) {
      return RB.Scripts.anySource(state, "trashToBanish", { controller: owner });
    },

    toTrash(state, iid) {
      const o = state.objs[iid];
      if (["board", "chain", "hand", "facedown", "deck"].indexOf(o.zone) < 0) return iid;
      if (o.zone !== "deck" && Flow.trashRedirectedToBanish(state, o.owner)) return Flow.toBanish(state, iid);
      return Flow.leaveToZone(state, iid, "trash");
    },

    leaveWithEvent(state, iid, zone, type, withController) {
      const from = Flow.leaveOrigin(state, iid);
      const nid = Flow.leaveToZone(state, iid, zone);
      if (nid) {
        const ev = { type: type, player: state.objs[nid].owner, iid: nid, fromIid: iid, from: from.loc, fromZone: from.zone };
        if (withController) ev.controller = from.controller;
        RB.FX.emit(state, ev);
      }
      return nid;
    },

    toBanish(state, iid) {
      return Flow.leaveWithEvent(state, iid, "banish", "banished", true);
    },

    toHand(state, iid) {
      return Flow.leaveWithEvent(state, iid, "hand", "toHand", false);
    },

    recallExhausted(state, iid, opts) {
      opts = opts || {};
      const o = state.objs[iid];
      Flow.recall(state, iid);
      if (opts.exhaust !== false) o.ready = false;
      if (opts.heal !== false) o.damage = [];
      o.designation = null;
      if (opts.log) Core.log(state, opts.log, { k: "death", p: o.controller, iids: [iid] });
      RB.FX.emit(state, { type: "recalled", iid: iid, player: o.controller });
      state.needCleanup = true;
    },

    recycleCards(state, iids) {
      const mains = {};
      const moved = {};
      for (const iid of iids) {
        const o = state.objs[iid];
        if (!o) continue;
        const isRune = Core.isType(state, iid, "rune");
        const owner = o.owner;
        moved[owner] = moved[owner] || [];
        moved[owner].push({ iid: iid, card: Core.cardId(state, iid), fromZone: o.zone, rune: isRune });
        const nid = Flow.leaveToZone(state, iid, isRune ? "runeDeck" : "deck");
        if (!nid) continue;
        if (!isRune) {
          mains[owner] = mains[owner] || [];
          mains[owner].push(nid);
        }
      }
      for (const ownerKey in mains) {
        const arr = mains[ownerKey];
        Kernel.shuffle(state, arr);
        for (const iid of arr) state.players[ownerKey].mainDeck.push(iid);
      }

      for (const ownerKey in moved) {
        for (const m of moved[ownerKey]) {
          if (!m.rune) continue;
          RB.FX.emit(state, { type: "recycleRune", iid: m.iid, player: +ownerKey, card: m.card, fromZone: m.fromZone, domain: null });
        }
        const cards = moved[ownerKey].filter(function (m) { return !m.rune; });
        if (cards.length) {
          RB.FX.emit(state, {
            type: "recycledCards", player: +ownerKey, n: cards.length, cards: cards,
          });
        }
      }
      for (const ownerKey in mains) {
        RB.FX.emit(state, { type: "recycled", player: +ownerKey, n: mains[ownerKey].length });
      }
      state.needCleanup = true;
    },

    removeFromZoneLists(state, iid) {
      const o = state.objs[iid];
      for (const pl of state.players) {
        for (const zone of ["hand", "mainDeck", "runeDeck", "trash", "banish", "champion"]) {
          const idx = pl[zone].indexOf(iid);
          if (idx >= 0) pl[zone].splice(idx, 1);
        }
      }
      for (const bfIid of state.battlefields) Flow.clearHidden(state, bfIid, iid);
      const ci = state.chain.findIndex(function (it) { return it.iid === iid; });
      if (ci >= 0 && o.zone === "chain") state.chain.splice(ci, 1);
      o.loc = null;
    },

    detach(state, iid) {
      const o = state.objs[iid];
      if (!o.attachedTo) return;
      const host = state.objs[o.attachedTo];
      if (host) {
        const idx = host.attachments.indexOf(iid);
        if (idx >= 0) host.attachments.splice(idx, 1);
        o.loc = host.loc || o.loc;
        if (o.flags.copySet) {
          delete host.copyCard;
          delete host.copyToken;
          Core.log(state, Core.name(state, host.iid) + " is no longer a copy (" + Core.name(state, iid) + " detached).",
            { k: "state", p: host.controller, iids: [host.iid, iid] });
        }
      }
      o.flags.copySet = false;
      o.attachedTo = null;
      state.needCleanup = true;
      RB.FX.emit(state, { type: "detached", iid: iid, host: host ? host.iid : null, player: o.controller });
    },

    attach(state, iid, hostIid) {
      const o = state.objs[iid];
      if (o.attachedTo === hostIid) return;
      if (o.attachedTo) Flow.detach(state, iid);
      const host = state.objs[hostIid];
      host.attachments.push(iid);
      o.attachedTo = hostIid;
      o.loc = host.loc;
      o.flags.attachedTurn = state.turn.num;
      state.needCleanup = true;
      RB.FX.emit(state, { type: "attached", iid: iid, host: hostIid, player: host.controller });
      const sc = RB.Scripts.forCard(state, iid);
      if (sc && sc.onAttach) {
        state.triggerQueue.push({
          controller: host.controller,
          source: iid,
          label: Core.name(state, iid) + ": on attach",
          program: sc.onAttach.program,
          targetSpecs: sc.onAttach.targets || [],
          optional: !!sc.onAttach.optional,
          ctx: { host: hostIid, bf: host.loc && host.loc.t === "bf" ? host.loc.iid : null },
        });
      }
    },

    discard(state, p, iids) {
      let n2 = 0;
      const newIds = [];
      for (const iid of iids) {
        const o = state.objs[iid];
        if (!o || o.zone !== "hand") continue;
        const nid = Flow.toTrash(state, iid);
        if (nid) newIds.push(nid);
        state.turnFacts.players[p].discarded = true;
        RB.FX.emit(state, { type: "discarded", player: p, iid: iid, trashIid: nid });
        n2++;
      }
      if (n2 > 0) RB.FX.emit(state, { type: "discardedBatch", player: p, n: n2 });
      return newIds;
    },

    burnCards(state, p, n) {
      const player = state.players[p];
      for (let i = 0; i < n; i++) {
        if (!Flow.refillDeck(state, p)) {
          if (state.over) return;
          continue;
        }
        const iid = player.mainDeck.shift();
        const o = state.objs[iid];
        o.zone = "trash";
        player.trash.push(iid);
        RB.FX.emit(state, { type: "burned", player: p, iid: iid });
      }
    },
  });
})();
